module.exports = __webpack_public_path__ + "img/weixin.33ea0d04.png";